// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-G":"G_outdoor-recreation-G__9D3qw"};